<template>
  <div id="dataAnalyse">
    <div v-if="!isNotDataFlag">
      <div class="rowFloor1">
        <span class="viewBox1">
          <span class="viewBox_head">
            <span class="viewHead_title" v-text="'报名数据'"></span>
            <span
              class="viewHead_icon"
              @click="
                clickPublicTheme(
                  renderThemeList && renderThemeList[0]
                    ? renderThemeList[0]
                    : {}
                )
              "
            >
              <svg
                t="1692698307306"
                class="publishBtn_icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="9670"
                width="50%"
                height="50%"
              >
                <path
                  d="M853.333333 533.333333a32 32 0 0 1 64 0v266.666667c0 64.8-52.533333 117.333333-117.333333 117.333333H224c-64.8 0-117.333333-52.533333-117.333333-117.333333V256c0-64.8 52.533333-117.333333 117.333333-117.333333h277.333333a32 32 0 0 1 0 64H224a53.333333 53.333333 0 0 0-53.333333 53.333333v544a53.333333 53.333333 0 0 0 53.333333 53.333333h576a53.333333 53.333333 0 0 0 53.333333-53.333333V533.333333z m-42.058666-277.333333l-89.792-95.402667a32 32 0 0 1 46.613333-43.861333l140.544 149.333333C927.861333 286.485333 913.376 320 885.333333 320H724.704C643.029333 320 576 391.210667 576 480v192a32 32 0 1 1-64 0V480c0-123.296 94.784-224 212.704-224h86.570667z"
                  p-id="9671"
                ></path>
              </svg>
            </span>
          </span>
          <span
            class="viewBox_body"
            v-if="
              renderThemeList &&
              renderThemeList[0] &&
              renderThemeList[0].graphicsId === 1001
            "
          >
            <span class="signupData_box">
              <HTML_SIGNUPDATA
                :datas="renderThemeList[0].renderData"
                :currThemeObj="currThemeObj"
              ></HTML_SIGNUPDATA>
            </span>
          </span>
        </span>
        <span class="viewBox1">
          <span class="viewBox_head">
            <span class="viewHead_title" v-text="'年龄分布'"></span>
            <span
              class="viewHead_icon"
              @click="
                clickPublicTheme(
                  renderThemeList && renderThemeList[1]
                    ? renderThemeList[1]
                    : {}
                )
              "
            >
              <svg
                t="1692698307306"
                class="publishBtn_icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="9670"
                width="50%"
                height="50%"
              >
                <path
                  d="M853.333333 533.333333a32 32 0 0 1 64 0v266.666667c0 64.8-52.533333 117.333333-117.333333 117.333333H224c-64.8 0-117.333333-52.533333-117.333333-117.333333V256c0-64.8 52.533333-117.333333 117.333333-117.333333h277.333333a32 32 0 0 1 0 64H224a53.333333 53.333333 0 0 0-53.333333 53.333333v544a53.333333 53.333333 0 0 0 53.333333 53.333333h576a53.333333 53.333333 0 0 0 53.333333-53.333333V533.333333z m-42.058666-277.333333l-89.792-95.402667a32 32 0 0 1 46.613333-43.861333l140.544 149.333333C927.861333 286.485333 913.376 320 885.333333 320H724.704C643.029333 320 576 391.210667 576 480v192a32 32 0 1 1-64 0V480c0-123.296 94.784-224 212.704-224h86.570667z"
                  p-id="9671"
                ></path>
              </svg>
            </span>
          </span>
          <span
            class="viewBox_body"
            v-if="
              renderThemeList &&
              renderThemeList[1] &&
              renderThemeList[1].graphicsId === 1002
            "
          >
            <PLAYERAGERADAR
              :datas="renderThemeList[1].renderData"
              :currThemeObj="currThemeObj"
            ></PLAYERAGERADAR>
          </span>
        </span>
        <span class="viewBox1">
          <span class="viewBox_head">
            <span class="viewHead_title" v-text="'选手地域分布'"></span>
            <span
              class="viewHead_icon"
              @click="
                clickPublicTheme(
                  renderThemeList && renderThemeList[2]
                    ? renderThemeList[2]
                    : {}
                )
              "
            >
              <svg
                t="1692698307306"
                class="publishBtn_icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="9670"
                width="50%"
                height="50%"
              >
                <path
                  d="M853.333333 533.333333a32 32 0 0 1 64 0v266.666667c0 64.8-52.533333 117.333333-117.333333 117.333333H224c-64.8 0-117.333333-52.533333-117.333333-117.333333V256c0-64.8 52.533333-117.333333 117.333333-117.333333h277.333333a32 32 0 0 1 0 64H224a53.333333 53.333333 0 0 0-53.333333 53.333333v544a53.333333 53.333333 0 0 0 53.333333 53.333333h576a53.333333 53.333333 0 0 0 53.333333-53.333333V533.333333z m-42.058666-277.333333l-89.792-95.402667a32 32 0 0 1 46.613333-43.861333l140.544 149.333333C927.861333 286.485333 913.376 320 885.333333 320H724.704C643.029333 320 576 391.210667 576 480v192a32 32 0 1 1-64 0V480c0-123.296 94.784-224 212.704-224h86.570667z"
                  p-id="9671"
                ></path>
              </svg>
            </span>
          </span>
          <span
            class="viewBox_body"
            v-if="
              renderThemeList &&
              renderThemeList[2] &&
              renderThemeList[2].graphicsId === 1003
            "
          >
            <PLAYERDISTRIBUTEPIE
              :datas="renderThemeList[2].renderData"
              :currThemeObj="currThemeObj"
            ></PLAYERDISTRIBUTEPIE>
          </span>
        </span>
      </div>
      <div class="rowFloor2">
        <span class="viewBox1">
          <span class="viewBox_head">
            <span class="viewHead_title" v-text="'数据监控'"></span>
            <span
              class="viewHead_icon"
              @click="
                clickPublicTheme(
                  renderThemeList && renderThemeList[3]
                    ? renderThemeList[3]
                    : {}
                )
              "
            >
              <svg
                t="1692698307306"
                class="publishBtn_icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="9670"
                width="50%"
                height="50%"
              >
                <path
                  d="M853.333333 533.333333a32 32 0 0 1 64 0v266.666667c0 64.8-52.533333 117.333333-117.333333 117.333333H224c-64.8 0-117.333333-52.533333-117.333333-117.333333V256c0-64.8 52.533333-117.333333 117.333333-117.333333h277.333333a32 32 0 0 1 0 64H224a53.333333 53.333333 0 0 0-53.333333 53.333333v544a53.333333 53.333333 0 0 0 53.333333 53.333333h576a53.333333 53.333333 0 0 0 53.333333-53.333333V533.333333z m-42.058666-277.333333l-89.792-95.402667a32 32 0 0 1 46.613333-43.861333l140.544 149.333333C927.861333 286.485333 913.376 320 885.333333 320H724.704C643.029333 320 576 391.210667 576 480v192a32 32 0 1 1-64 0V480c0-123.296 94.784-224 212.704-224h86.570667z"
                  p-id="9671"
                ></path>
              </svg>
            </span>
          </span>
          <span
            class="viewBox_body"
            v-if="
              renderThemeList &&
              renderThemeList[3] &&
              renderThemeList[3].graphicsId === 1004
            "
          >
            <PLAYERCONTROLPIE
              :datas="renderThemeList[3].renderData"
              :currThemeObj="currThemeObj"
            ></PLAYERCONTROLPIE>
          </span>
        </span>
        <span class="viewBox2">
          <span class="viewBox_head">
            <span class="viewHead_title" v-text="'计时点分布数据'"></span>
            <span class="viewHead_icon">
              <svg
                t="1692698307306"
                class="publishBtn_icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="9670"
                width="50%"
                height="50%"
              >
                <path
                  d="M853.333333 533.333333a32 32 0 0 1 64 0v266.666667c0 64.8-52.533333 117.333333-117.333333 117.333333H224c-64.8 0-117.333333-52.533333-117.333333-117.333333V256c0-64.8 52.533333-117.333333 117.333333-117.333333h277.333333a32 32 0 0 1 0 64H224a53.333333 53.333333 0 0 0-53.333333 53.333333v544a53.333333 53.333333 0 0 0 53.333333 53.333333h576a53.333333 53.333333 0 0 0 53.333333-53.333333V533.333333z m-42.058666-277.333333l-89.792-95.402667a32 32 0 0 1 46.613333-43.861333l140.544 149.333333C927.861333 286.485333 913.376 320 885.333333 320H724.704C643.029333 320 576 391.210667 576 480v192a32 32 0 1 1-64 0V480c0-123.296 94.784-224 212.704-224h86.570667z"
                  p-id="9671"
                ></path>
              </svg>
            </span>
          </span>
          <span class="viewBox_body"></span>
        </span>
      </div>
      <div class="rowFloor3">
        <span
          class="viewBox3"
          v-for="themeItem in rankList"
          :key="themeItem.analysisItemId"
        >
          <span class="viewBox_head">
            <span
              class="viewHead_title"
              v-text="themeItem.analysisItemName"
            ></span>
            <span
              class="theme_select"
              v-for="selectItem in themeItem.filter.filterTypes"
              :key="selectItem.name"
            >
              <el-select
                v-show="selectItem.values && selectItem.values.length > 0"
                v-model="themeItem.actJson[selectItem.name]"
                placeholder="请选择"
                popper-class="theme_select_popper"
                :popper-append-to-body="false"
                :filterable="selectItem.vagueSelect"
                @change="
                  updateElOption(
                    themeItem.analysisItemId,
                    selectItem,
                    themeItem.filter.filterTypes,
                    themeItem.actJson
                  )
                "
              >
                <el-option
                  v-for="item in selectItem.values"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
            </span>
            <span
              class="viewHead_icon"
              @click="clickPublicTheme(themeItem && themeItem ? themeItem : {})"
            >
              <svg
                t="1692698307306"
                class="publishBtn_icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="9670"
                width="50%"
                height="50%"
              >
                <path
                  d="M853.333333 533.333333a32 32 0 0 1 64 0v266.666667c0 64.8-52.533333 117.333333-117.333333 117.333333H224c-64.8 0-117.333333-52.533333-117.333333-117.333333V256c0-64.8 52.533333-117.333333 117.333333-117.333333h277.333333a32 32 0 0 1 0 64H224a53.333333 53.333333 0 0 0-53.333333 53.333333v544a53.333333 53.333333 0 0 0 53.333333 53.333333h576a53.333333 53.333333 0 0 0 53.333333-53.333333V533.333333z m-42.058666-277.333333l-89.792-95.402667a32 32 0 0 1 46.613333-43.861333l140.544 149.333333C927.861333 286.485333 913.376 320 885.333333 320H724.704C643.029333 320 576 391.210667 576 480v192a32 32 0 1 1-64 0V480c0-123.296 94.784-224 212.704-224h86.570667z"
                  p-id="9671"
                ></path>
              </svg>
            </span>
          </span>
          <span
            class="viewBox_body"
            v-if="
              themeItem.renderData.data.dataList &&
              themeItem.renderData.data.dataList.length > 0
            "
          >
            <HTML_RANKLISTCARD
              :datas="themeItem.renderData"
              :currThemeObj="currThemeObj"
            ></HTML_RANKLISTCARD>
            <!-- <span
              class="rankList_item"
              v-for="item in themeItem.renderData.data.dataList"
              :key="item.rank"
            >
              <span class="rankItem_left">
                <span class="left_rank" v-text="item.rank"></span>
                <span class="left_infor">
                  <span class="leftInfor_name" v-text="item.athleteName"></span>
                  <span class="leftInfor_num" v-text="item.athleteNum"></span>
                </span>
              </span>
              <span class="rankItem_right" v-text="item.num"></span>
            </span> -->
          </span>
        </span>
      </div>
    </div>
    <marathon_notData
      v-if="isNotDataFlag"
      :className="'relativePt60'"
    ></marathon_notData>
  </div>
</template>

<script>
import HTML_SIGNUPDATA from '@components/marathon/html/signupData.vue'
import PLAYERAGERADAR from '@components/marathon/echarts/radar/playerAgeRadar.vue'
import PLAYERDISTRIBUTEPIE from '@components/marathon/echarts/pie/playerDistributePie.vue'
import PLAYERCONTROLPIE from '@components/marathon/echarts/pie/playerControlPie.vue'
import HTML_RANKLISTCARD from '@components/marathon/html/rankListCard.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
import marathon_notData from '@components/base/NO_DATA.vue'
import platfrom_refresh_data_mixin from '@mixins/platfrom_refresh_data'
import {
  https_package_findAnalysisItem,
  https_package_getMoreDataByAnalysisID,
} from '@api/platfrom_base_api'

export default {
  name: 'dataAnalyse',
  components: {
    HTML_SIGNUPDATA,
    PLAYERAGERADAR,
    PLAYERDISTRIBUTEPIE,
    PLAYERCONTROLPIE,
    HTML_RANKLISTCARD,
    marathon_notData,
  },
  mixins: [cup_base_data_mixin, platfrom_refresh_data_mixin],
  data() {
    return {
      themeTemplateType: 1001,
      renderThemeList: null,
      rankList: null,
      isNotDataFlag: false,
    }
  },
  created() {
    // this.renderData = {
    //   objectInfo: [
    //     {
    //       teamName: '荷兰',
    //       teamId: 1054,
    //       teamLogo: 'https://images.mixtmt.com/hyper/football/team/1054.png',
    //       teamScore: 3,
    //       playerName: '',
    //       personNameEn: '',
    //       playerId: 0,
    //       profilePicture: 'players.png',
    //       position: '',
    //       shirtNumber: 0,
    //       positionName: null,
    //       age: null,
    //       height: null,
    //       weight: null,
    //     },
    //     {
    //       teamName: '美国',
    //       teamId: 1056,
    //       teamLogo: 'https://images.mixtmt.com/hyper/football/team/1056.png',
    //       teamScore: 1,
    //       playerName: '',
    //       personNameEn: '',
    //       playerId: 0,
    //       profilePicture: 'players.png',
    //       position: '',
    //       shirtNumber: 0,
    //       positionName: null,
    //       age: null,
    //       height: null,
    //       weight: null,
    //     },
    //   ],
    //   templateId: 1051,
    //   statisticsModels: [
    //     {
    //       id: 3379,
    //       name: '18-25',
    //       tableName: null,
    //       columnName: 'goals',
    //       type: null,
    //       sort: 1,
    //       statisticalEn: 'goals',
    //       suffix: '',
    //       isAuto: true,
    //     },
    //     {
    //       id: 3383,
    //       name: '65+',
    //       tableName: null,
    //       columnName: 'test',
    //       type: null,
    //       sort: 6,
    //       statisticalEn: 'test',
    //       suffix: '',
    //       isAuto: true,
    //     },
    //     {
    //       id: 3382,
    //       name: '56-65',
    //       tableName: null,
    //       columnName: 'passes',
    //       type: null,
    //       sort: 5,
    //       statisticalEn: 'passes',
    //       suffix: '',
    //       isAuto: true,
    //     },
    //     {
    //       id: 2126,
    //       name: '46-55',
    //       tableName: null,
    //       columnName: 'clearances',
    //       type: null,
    //       sort: 4,
    //       statisticalEn: 'clearances',
    //       suffix: '',
    //       isAuto: true,
    //     },
    //     {
    //       id: 2112,
    //       name: '33-45',
    //       tableName: null,
    //       columnName: 'shots_on_target',
    //       type: null,
    //       sort: 3,
    //       statisticalEn: 'shotsOnTarget',
    //       suffix: '',
    //       isAuto: true,
    //     },
    //     {
    //       id: 2101,
    //       name: '26-32',
    //       tableName: null,
    //       columnName: 'possession_percentage',
    //       type: null,
    //       sort: 2,
    //       statisticalEn: 'possessionPercentage',
    //       suffix: '',
    //       isAuto: true,
    //     },
    //   ],
    //   analysisItemId: '4550001b642b480b922a86d937ae8fd8',
    //   competitionId: 109,
    //   seasonId: 1039,
    //   matchId: null,
    //   graphicsId: 35,
    //   title: '球队本届对比雷达图',
    //   data: {
    //     dataList: [
    //       {
    //         goals: 10,
    //         possessionPercentage: 53,
    //         shotsOnTarget: 16,
    //         clearances: 85,
    //         passes: 2773,
    //         test: 80,
    //       },
    //     ],
    //     maxList: {
    //       goals: 100,
    //       possessionPercentage: 530,
    //       shotsOnTarget: 160,
    //       clearances: 850,
    //       passes: 27730,
    //       test: 120,
    //     },
    //   },
    //   limitCount: null,
    //   json: null,
    //   seasonOrMatch: true,
    //   haveCdvPackage: false,
    //   needPicture: false,
    //   needMax: true,
    // }
    this.init()
  },
  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      // const query = this.$route.query
      // this.cid = 101 //query.cid
      // this.sid = 10001 //query.sid
      // this.mid = 0 //query.mid
      this.cid = this.currCid
      this.sid = this.currSid //马拉松中赛季id就是比赛id
      this.mid = this.currSid
      this.renderThemeList = null
      this.rankList = null
      await this.findAnalysisItem(this.themeTemplateType)
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    clickPublicTheme(themeItem) {
      // 分享主题
      let newThemeItem = themeItem
      console.debug('newThemeItem:', newThemeItem)
      if (!newThemeItem.analysisItemName) {
        // 有的主题有analysisItemName，有的没有，比如积分榜，因此处理一下，分享主题到公共播单的接口dataItemName都取这个字段
        newThemeItem.analysisItemName = newThemeItem.title
      }
      window.mixtmtBase_eventBus.$emit('publicThemeDialogEvent', {
        flag: true,
        themeItem: newThemeItem,
        mid: this.mid,
      })
    },
    async updateElOption(
      analysisItemId,
      curSelectItem,
      filterTypes,
      actAllSelectObj
    ) {
      console.debug(
        '改变选择框',
        analysisItemId,
        curSelectItem,
        actAllSelectObj
      )
      this.themeAnalysisItemIdArr.forEach((themeAnalysisId, index) => {
        if (themeAnalysisId == analysisItemId) {
          this.jsonArr[index] = JSON.stringify(actAllSelectObj)
        }
      })
      await this.getMoreDataByAnalysisID({
        analysisId: `[${analysisItemId}]`,
        json: `[${JSON.stringify(actAllSelectObj)}]`,
        competitionId: this.cid,
        seasonId: this.sid,
        matchId: this.mid,
      })
    },
    async findAnalysisItem(templateType) {
      // 获取所有主题信息
      const params = {
        templateType,
        cid: this.cid,
        sid: this.sid,
        did: 0,
        eid: 0,
        pid: 0,
        mid: this.mid,
      }
      await https_package_findAnalysisItem(
        this.axiosBaseUrl,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            if (!res.data || (res.data && res.data.length == 0)) {
              this.isNotDataFlag = true
            } else {
              this.isNotDataFlag = false
            }
            this.themeAnalysisItemIdArr = []
            this.jsonArr = []
            this.themeList = res.data.map((item) => {
              this.themeAnalysisItemIdArr.push(item.analysisItemId)
              this.jsonArr.push(item.json)
              let newItem = JSON.parse(JSON.stringify(item))
              newItem.actJson = JSON.parse(newItem.json)
              newItem.renderData = null
              if (newItem.analysisItemStyles) {
                // 如果 analysisItemStyles 个数只有1个，则默认选第一个，如果有多个则不需要选默认的
                let initAct =
                  newItem.analysisItemStyles.length === 1 ? true : false
                newItem.analysisItemStyles.forEach((styleItem, styleIndex) => {
                  if (initAct && styleIndex === 0) {
                    styleItem.act = true
                  } else {
                    styleItem.act = false
                  }
                })
              }
              newItem.title2RightName =
                newItem.analysisItemStyles && newItem.analysisItemStyles.length
                  ? `${newItem.analysisItemStyles.length}种风格`
                  : ''
              return newItem
            })
            const params = {
              analysisId: `[${this.themeAnalysisItemIdArr.toString()}]`,
              json: `[${this.jsonArr.toString()}]`,
              competitionId: this.cid,
              seasonId: this.sid,
              matchId: this.mid,
            }
            this.getMoreDataByAnalysisID(params)
            if (
              this.isRefresh &&
              this.refreshCallbackHandle &&
              !this.setIntervalId
            ) {
              this.refreshCallbackHandle(this.refreshCallback)
            }
            console.debug('this.jsonArr:', this.jsonArr)
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getMoreDataByAnalysisID(params) {
      // 根据获取的主题信息，去加载相应的主题数据，这一步完成才能渲染主题
      await https_package_getMoreDataByAnalysisID(
        this.axiosBaseUrl,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            if (this.renderThemeList) {
              let renderThemeList = this.renderThemeList
              res.data.forEach((newRenderData) => {
                renderThemeList.forEach((oldTheme) => {
                  if (oldTheme.analysisItemId == newRenderData.analysisItemId) {
                    oldTheme.renderData = newRenderData
                    oldTheme.analysisItemName =
                      newRenderData && newRenderData.title
                        ? newRenderData.title
                        : ''
                  }
                })
              })
              this.renderThemeList = renderThemeList
            } else {
              // 全部更换数
              this.renderThemeList = this.themeList.map((theme, index) => {
                if (res.data[index]) {
                  theme.renderData = res.data[index]
                  theme.analysisItemName =
                    res.data[index] && res.data[index].title
                      ? res.data[index].title
                      : ''
                }
                return theme
              })
            }
            this.rankList = this.renderThemeList.slice(4)
            console.debug(
              'renderThemeList:',
              this.renderThemeList,
              this.rankList
            )
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#dataAnalyse {
  padding: 2.083vw 0;
  .rowFloor1,
  .rowFloor2,
  .rowFloor3 {
    width: 100%;
    height: auto;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: flex-start;
    padding-bottom: 1.66vw;
    .viewBox1,
    .viewBox2,
    .viewBox3 {
      margin-right: 1.66vw;
      width: 27.08vw;
      height: 22.22vw;
      background-color: #fff;
      border-radius: 0.694vw;
      border: 1px solid var(--mixtmt_greyColor7);
      &:last-child {
        margin-right: 0;
      }
      .viewBox_head {
        position: relative;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        height: 3.2vw;
        padding: 0 3.125vw 0 1.042vw;
        border-bottom: 1px solid var(--mixtmt_greyColor7);
        .viewHead_title {
          flex: 1;
          font-size: 1.11vw;
          font-weight: bold;
          color: var(--mixtmt_greyColor3);
        }
        .viewHead_icon {
          position: absolute;
          right: 0;
          z-index: 5;
          width: 3.125vw;
          height: 3.125vw;
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          svg.publishBtn_icon {
            fill: var(--mixtmt_greyColor4);
          }
        }
      }
      .viewBox_body {
        display: block;
        width: 100%;
        height: 19.02vw;
        .signupData_box {
          display: block;
          width: 100%;
          height: auto;
        }
      }
    }
    .viewBox2 {
      width: calc(100% - 27.08vw);
    }
  }
  .rowFloor2 {
    .viewBox1 {
      width: calc(27.08vw - 1.66vw);
      .viewBox_body {
        padding: 1.042vw 1.042vw 0 1.042vw;
      }
    }
  }
  .rowFloor3 {
    .viewBox3 {
      width: 19.895vw;
      height: auto;
      .viewBox_head {
        justify-content: space-between;
        .theme_select {
          width: 6.027vw;
          margin-right: 0;
          &:last-child {
            margin-right: 0;
          }
        }
      }
      .viewBox_body {
        height: auto;
        .rankList_item {
          width: 100%;
          height: auto;
          display: flex;
          display: -webkit-flex;
          justify-content: space-between;
          align-items: center;
          padding: 0.694vw 1.388vw 0.694vw 0.694vw;
          &:first-child {
            .rankItem_left {
              .left_rank {
                background-color: var(--mixtmt_subColor3_1);
              }
            }
          }
          .rankItem_left {
            width: 60%;
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
            .left_rank {
              width: 1.388vw;
              height: 1.388vw;
              background-color: var(--mixtmt_mainColor6);
              color: var(--mixtmt_whiteColor);
              font-size: 0.972vw;
              line-height: 1.388vw;
              text-align: center;
              border-radius: 50%;
            }
            .left_infor {
              width: calc(100% - 1.388vw);
              padding: 0 0.694vw;
              display: flex;
              display: -webkit-flex;
              justify-content: center;
              align-items: flex-start;
              flex-direction: column;
              .leftInfor_name {
                width: 100%;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                font-size: 0.972vw;
                line-height: 1.11vw;
                font-weight: bold;
                color: var(--mixtmt_greyColor3);
              }
              .leftInfor_num {
                width: 100%;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                font-size: 0.833vw;
                line-height: 1.11vw;
                color: var(--mixtmt_greyColor4);
              }
            }
          }
          .rankItem_right {
            width: 40%;
            display: flex;
            display: -webkit-flex;
            justify-content: flex-end;
            align-items: center;
            color: var(--mixtmt_subColor3_1);
            font-size: 0.972vw;
            line-height: 1.11vw;
          }
        }
      }
    }
  }
}
.mixtmt_pc {
  #dataAnalyse {
    .viewBox1,
    .viewBox2,
    .viewBox3 {
      .viewBox_head {
        .viewHead_icon {
          &:hover {
            cursor: pointer;
            svg.publishBtn_icon {
              fill: var(--mixtmt_subColor1_1);
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
#dataAnalyse {
  .theme_select {
    .el-select {
      .el-input {
        font-size: 0.972vw;
        .el-input__inner {
          height: 2.083vw;
          padding: 0 2.083vw 0 0.694vw;
          line-height: calc(2.083vw - 2px);
          border-radius: 0.278vw;
          &:focus,
          &:active {
            border-color: var(--mixtmt_mainColor8);
          }
        }
        .el-select__caret {
          font-size: 0.927vw;
        }
        .el-input__icon {
          width: 0.694vw;
          line-height: 2.083vw;
        }
      }
      .el-icon-arrow-up::before {
        content: '\e79a';
      }
    }
    .el-select .el-input .el-select__caret.is-reverse {
      -webkit-transform: rotateZ(180deg);
      transform: rotateZ(180deg);
    }
  }
  .el-select-dropdown__empty {
    padding: 1.11vw;
    font-size: 0.972vw;
  }
}
</style>
